"use client";

import type { ReactNode } from "react";
import { selectAreaSport } from "./area-sport-state";

/**
 * The one client island of the lower half of the area page (G3): a button that switches the
 * page to a sport through the shared sport state (area-sport-state.ts, owned by the hero toggle)
 * and scrolls back to the toggle so the reader sees the switched panels. Everything it wraps is
 * server-rendered.
 */
export function AreaSportPickButton({
  sport,
  primary,
  ariaLabel,
  className,
  children,
}: Readonly<{
  sport: string;
  primary: string;
  ariaLabel: string;
  className?: string;
  children: ReactNode;
}>) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      data-area-sport-pick={sport}
      onClick={() => selectAreaSport(sport, { primary, scroll: true })}
      className={className}
    >
      {children}
    </button>
  );
}
